ixModuleRouting("impactx.oci",
{
    "/ocijump": {
        template: "<ixa-oci-jump></ixa-oci-jump>",
        templateUrl:
            "modules/oci/templates/ocijump.html",
        controller: "OCIJumpCtrl",
        controllerAs: "ociJumpCtrl",
        workspace: "shop",
    }
});